<template>
    <div class="content">
        <div class="content-body" style="overflow: auto">
            <div style="display: flex;align-items: center">
                <div style="flex: 1;">
                    <slot name="title">
                    </slot>
                </div>
                <el-button
                        v-if="!hideRightBack"
                        size="mini"
                        icon="el-icon-back"
                        @click="onBack">
                    返回
                </el-button>
            </div>
            <div style="padding: 10px">
                <slot/>
            </div>
            <div style="text-align: center;padding: 10px" v-if="showBottom">
                <el-button type="" style="font-size: 12px" @click="$router.go(-1)">返回</el-button>
                <el-button type="primary" style="font-size: 12px" @click="$emit('save')">提交</el-button>
            </div>
        </div>
        <div class="content-footer">
          <span style="cursor: pointer;" class="font12 titlecolor">
          </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BaseExitLayout",
        props: {
            showBottom: {
                type: Boolean,
                default: true
            },
            hideRightBack: {
                type: Boolean,
                default: false
            },
            back:{
                type:Function
            }
        },
        methods: {
            onBack() {
                if(this.back){
                    this.back()
                }else {
                    this.$router.go(-1)
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

    .content {
        overflow: auto;
        max-height: 100%;
        min-height: 100%;

        .content-footer {
            flex-shrink: 0;
            height: 30px;
            text-align: center;
        }
    }

    .overview {
        padding: 20px;
        background-color: #ededed;
    }
</style>
